export { FooterModule } from './footer.module';
export { FooterComponent } from './footer.component';

